import React from "react";
import { useSelector } from "react-redux";
import { staticData } from "managers/staticDataManager";

const BannerContent = ({ platform, onCancel, onInstallClick }) => {
  if (!platform) return null;

  switch (platform) {
    case "ios":
      return (
        <>
          <p>{staticData.loadTerms(useSelector, "INSTALLBANNER_IOS")}</p>
          <a href="https://apps.apple.com/mk/app/seinet/id921966900" target="_blank" rel="noopener noreferrer">
            <button>{staticData.loadTerms(useSelector, "INSTALLBANNER_BTN_INSTALL")}</button>
          </a>
          <button onClick={onCancel}>{staticData.loadTerms(useSelector, "INSTALLBANNER_BTN_CANCEL")}</button>
        </>
      );
    case "huawei":
      return (
        <>
          <p>{staticData.loadTerms(useSelector, "INSTALLBANNER_HUAWEI")}</p>
          <a href="https://appgallery.huawei.com/app/C113958025" target="_blank" rel="noopener noreferrer">
            <button>{staticData.loadTerms(useSelector, "INSTALLBANNER_BTN_INSTALL")}</button>
          </a>
          <button onClick={onCancel}>{staticData.loadTerms(useSelector, "INSTALLBANNER_BTN_CANCEL")}</button>
        </>
      );
    case "androidPrompt":
      return (
        <>
          <p>{staticData.loadTerms(useSelector, "INSTALLBANNER_OTHEROS")}</p>
          <button onClick={onInstallClick}>{staticData.loadTerms(useSelector, "INSTALLBANNER_BTN_INSTALL")}</button>
          <button onClick={onCancel}>{staticData.loadTerms(useSelector, "INSTALLBANNER_BTN_CANCEL")}</button>
        </>
      );
    case "androidFallback":
      return (
        <>
          <p>{staticData.loadTerms(useSelector, "INSTALLBANNER_ANDROID")}</p>
          <a href="https://play.google.com/store/apps/details?id=com.mse.seinet" target="_blank" rel="noopener noreferrer">
            <button>{staticData.loadTerms(useSelector, "INSTALLBANNER_BTN_INSTALL")}</button>
          </a>
          <button onClick={onCancel}>{staticData.loadTerms(useSelector, "INSTALLBANNER_BTN_CANCEL")}</button>
        </>
      );
    default:
      return null;
  }
};

export default BannerContent;
